import ThemeLexus from './Lexus/ThemeLexus';
import ThemeToyota from './Toyota/ThemeToyota';

const THEME = process.env.REACT_APP_APP_THEME;
const BRAND = process.env.REACT_APP_THEME_BRAND;


const theme = {
  ...{
    ...ThemeLexus,
    ...ThemeToyota,
  }[BRAND][THEME],
};

export default theme;
